module.exports = __webpack_public_path__ + "img/bombeirinho.705816a2.jpeg";